import "core-js/modules/es.json.parse.js";
import { readExcelFromRemoteFile } from "@/utils/word.js";
export default {
  name: "agreement-user",
  data() {
    let language = JSON.parse(localStorage.getItem("language")) || "zh-CN";
    return {
      vHtml: "",
      wordURL: `https://usercenter-1251575231.cos.ap-shanghai.myqcloud.com/policy/iWork%E7%94%A8%E6%88%B7%E5%8D%8F%E8%AE%AE-V1.2-${language}.docx`
    };
  },
  created() {
    readExcelFromRemoteFile(this.wordURL, value => {
      this.$nextTick(() => {
        this.vHtml = value;
      });
    });
  }
};